import type { PoiData } from '$lib/components/pois/types';
import { browser, dev } from '$app/environment';
import { poiTypeTrackerNames } from '$lib/components/pois/constants';
import { isAccommodationMichelinPoi, isRestaurantMichelinPoi } from '$lib/components/pois/utils';
import { META_PIXEL_QUEUE_ID, META_PIXEL_VENDOR_ID } from '$lib/services/tracking/metaPixel/constant';
import { type MetaBookLeadPayload, type MetaDatasheetViewContentPayload, metaPixelActions, type MetaPixelTrackingEvents } from '$lib/services/tracking/metaPixel/types';
import { useTrackingQueue } from '$lib/services/tracking/utils/trackingQueue';
import { isNogarnish } from '$lib/utils/nogarnish';

const { runEvent, passivePollingUntilReady } = useTrackingQueue<MetaPixelTrackingEvents>(META_PIXEL_QUEUE_ID, META_PIXEL_VENDOR_ID);

passivePollingUntilReady(() => Boolean(window.fbq));

function metaPixelTrack(event: MetaPixelTrackingEvents) {
	if (!browser || isNogarnish() || !window.fbq) {
		return () => {};
	}

	const { action } = event;
	const payload = { ...(event as { payload?: any }).payload };

	if (dev) {
		// eslint-disable-next-line no-console
		console.log(`track:metaPixel ${action}`, payload);
	}

	window.fbq?.('track', event, payload);
}

export function getDatasheetViewContentPayload(poi: PoiData): MetaDatasheetViewContentPayload {
	const isMichelinSelection = isAccommodationMichelinPoi(poi) || isRestaurantMichelinPoi(poi);
	return {
		content_category: poiTypeTrackerNames[poi.__typename],
		michelin_selection: isMichelinSelection ? 'true' : 'false',
	};
}

export function getBookLeadPayload(poi: PoiData): MetaBookLeadPayload {
	return {
		content_category: poiTypeTrackerNames[poi.__typename],
	};
}

export function metaTrackDatasheetViewContent(payload: MetaDatasheetViewContentPayload) {
	runEvent(metaPixelTrack, { action: metaPixelActions.VIEW_CONTENT, payload });
}

export function metaTrackBookLead(payload: MetaBookLeadPayload) {
	runEvent(metaPixelTrack, { action: metaPixelActions.LEAD, payload });
}

export function metaTrackPageView() {
	runEvent(metaPixelTrack, { action: metaPixelActions.PAGE_VIEW });
}
